import React from 'react';

const MissionStatement = () => {
  return (
    <section
      id="mission"
      className="bg-white py-12 px-4 border-b border-gray-100 text-center"
    >
      <div className="max-w-4xl mx-auto">
        <p className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-800 tracking-tight leading-snug animate-fade-in-up">
          Empowering Nigerians to shop smarter, faster, and globally — all in one click.
        </p>
      </div>
    </section>
  );
};

export default MissionStatement;
